// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInvoiceStatusType } from './IInvoiceStatusType';
import {
    IInvoiceStatusTypeFromJSON,
    IInvoiceStatusTypeFromJSONTyped,
    IInvoiceStatusTypeToJSON,
    IInvoiceStatusTypeToJSONTyped,
} from './IInvoiceStatusType';
import type { IInvoiceType } from './IInvoiceType';
import {
    IInvoiceTypeFromJSON,
    IInvoiceTypeFromJSONTyped,
    IInvoiceTypeToJSON,
    IInvoiceTypeToJSONTyped,
} from './IInvoiceType';

/**
 * 
 * @export
 * @interface IInvoiceDashboardAggregatorDto
 */
export interface IInvoiceDashboardAggregatorDto {
    /**
     * 
     * @type {number}
     * @memberof IInvoiceDashboardAggregatorDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {IInvoiceStatusType}
     * @memberof IInvoiceDashboardAggregatorDto
     */
    invoice_status_type?: IInvoiceStatusType;
    /**
     * 
     * @type {Date}
     * @memberof IInvoiceDashboardAggregatorDto
     */
    ended_at?: Date;
    /**
     * 
     * @type {number}
     * @memberof IInvoiceDashboardAggregatorDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvoiceDashboardAggregatorDto
     */
    organization_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IInvoiceDashboardAggregatorDto
     */
    large_organization_logo?: string;
    /**
     * 
     * @type {IInvoiceType}
     * @memberof IInvoiceDashboardAggregatorDto
     */
    invoice_type?: IInvoiceType;
    /**
     * 
     * @type {string}
     * @memberof IInvoiceDashboardAggregatorDto
     */
    ach_method?: IInvoiceDashboardAggregatorDtoAchMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof IInvoiceDashboardAggregatorDto
     */
    account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvoiceDashboardAggregatorDto
     */
    account_description?: string;
    /**
     * 
     * @type {string}
     * @memberof IInvoiceDashboardAggregatorDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IInvoiceDashboardAggregatorDto
     */
    account_number_last4?: string;
    /**
     * 
     * @type {string}
     * @memberof IInvoiceDashboardAggregatorDto
     */
    routing_transit_number?: string;
}

/**
* @export
* @enum {string}
*/
export enum IInvoiceDashboardAggregatorDtoAchMethodEnum {
    NONE = 'NONE',
    PUSH = 'PUSH',
    PULL = 'PULL'
}


/**
 * Check if a given object implements the IInvoiceDashboardAggregatorDto interface.
 */
export function instanceOfIInvoiceDashboardAggregatorDto(value: object): value is IInvoiceDashboardAggregatorDto {
    return true;
}

export function IInvoiceDashboardAggregatorDtoFromJSON(json: any): IInvoiceDashboardAggregatorDto {
    return IInvoiceDashboardAggregatorDtoFromJSONTyped(json, false);
}

export function IInvoiceDashboardAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvoiceDashboardAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'invoice_status_type': json['invoice_status_type'] == null ? undefined : IInvoiceStatusTypeFromJSON(json['invoice_status_type']),
        'ended_at': json['ended_at'] == null ? undefined : (new Date(json['ended_at'])),
        'amount': json['amount'] == null ? undefined : json['amount'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'large_organization_logo': json['large_organization_logo'] == null ? undefined : json['large_organization_logo'],
        'invoice_type': json['invoice_type'] == null ? undefined : IInvoiceTypeFromJSON(json['invoice_type']),
        'ach_method': json['ach_method'] == null ? undefined : json['ach_method'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'account_description': json['account_description'] == null ? undefined : json['account_description'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'account_number_last4': json['account_number_last4'] == null ? undefined : json['account_number_last4'],
        'routing_transit_number': json['routing_transit_number'] == null ? undefined : json['routing_transit_number'],
    };
}

export function IInvoiceDashboardAggregatorDtoToJSON(json: any): IInvoiceDashboardAggregatorDto {
    return IInvoiceDashboardAggregatorDtoToJSONTyped(json, false);
}

export function IInvoiceDashboardAggregatorDtoToJSONTyped(value?: IInvoiceDashboardAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoice_id': value['invoice_id'],
        'invoice_status_type': IInvoiceStatusTypeToJSON(value['invoice_status_type']),
        'ended_at': value['ended_at'] == null ? undefined : ((value['ended_at']).toISOString()),
        'amount': value['amount'],
        'organization_name': value['organization_name'],
        'large_organization_logo': value['large_organization_logo'],
        'invoice_type': IInvoiceTypeToJSON(value['invoice_type']),
        'ach_method': value['ach_method'],
        'account_id': value['account_id'],
        'account_description': value['account_description'],
        'external_identifier': value['external_identifier'],
        'account_number_last4': value['account_number_last4'],
        'routing_transit_number': value['routing_transit_number'],
    };
}

